var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible"
        }
      ],
      staticClass: "modal",
      style: {
        backgroundColor: _vm.isNeedBg ? "rgba(0, 0, 0, .4)" : "rgba(0, 0, 0, 0)"
      },
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.clickBack.apply(null, arguments)
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible"
            }
          ],
          class: _vm.dialogClassObj,
          style: { width: _vm.theWidth },
          on: { click: function() {} }
        },
        [
          _c(
            "div",
            { staticClass: "modal-content" },
            [
              _vm._t("modal-header", function() {
                return [
                  _c("div", { staticClass: "modal-header" }, [
                    _vm.isNeedCloseBtn
                      ? _c(
                          "button",
                          {
                            staticClass: "close",
                            attrs: { type: "button" },
                            on: { click: _vm.close }
                          },
                          [_c("span", [_vm._v("×")])]
                        )
                      : _vm._e(),
                    _c("p", { staticClass: "modal-title" }, [
                      _vm._v(_vm._s(_vm.title))
                    ])
                  ])
                ]
              }),
              _c(
                "div",
                {
                  staticClass: "modal-body cc-scroll",
                  style: { height: _vm.height + "px" }
                },
                [_vm._t("modal-body")],
                2
              ),
              _vm._t("modal-footer", function() {
                return [
                  _c(
                    "div",
                    { staticClass: "modal-footer" },
                    [
                      _c(
                        "cc-button",
                        {
                          attrs: { type: "confirm" },
                          on: { click: _vm.callback }
                        },
                        [_vm._v("确定")]
                      ),
                      _c(
                        "cc-button",
                        { attrs: { type: "gray" }, on: { click: _vm.close } },
                        [_vm._v("取消")]
                      )
                    ],
                    1
                  )
                ]
              })
            ],
            2
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c9c6948e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9c6948e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Cc-Modal/Modal.vue
// module id = W3bk
// module chunks = 1 2